<div class="detail-header">
  <h2>Impersonation Activity</h2>
  <button type="button" class="btn btn-icon" (click)="close()" title="Close">
    <i class="icon-x icon-action-blue"></i>
  </button>
</div>

<div class="detail-body" mat-dialog-content>
  <div class="detail-row">
    <span class="detail-label">Performed By</span>
    <span class="detail-value">{{ log.RealUserName }} <span class="muted">(#{{ log.RealUserId }})</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Impersonated</span>
    <span class="detail-value">{{ log.ImpersonatedUserName }} <span class="muted">(#{{ log.ImpersonatedUserId }})</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">When</span>
    <span class="detail-value">{{ log.CreatedDateUTC | date:'yyyy-MM-dd HH:mm:ss' }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Request</span>
    <span class="detail-value">{{ log.HttpMethod }} {{ log.RequestPath }}</span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Status</span>
    <span class="detail-value">{{ log.StatusCode }}</span>
  </div>
  @if (log.QueryString) {
    <div class="detail-row">
      <span class="detail-label">Query String</span>
      <span class="detail-value">{{ log.QueryString }}</span>
    </div>
  }
  <div class="detail-section">
    <span class="detail-label">Request Body</span>
    @if (prettyBody) {
      <pre class="detail-pre">{{ prettyBody }}</pre>
    } @else {
      <span class="muted">(none)</span>
    }
  </div>
</div>
